export default __webpack_public_path__ + "static/media/02_photo.137e14e3.jpg";